<template>
  <div>
    <el-card style="margin-bottom:5px"
             :body-style="{ padding: '10px'}"
             shadow="nerver">
      <!-- ------------------------推荐类型------------------------ -->
      <el-tabs v-model="activeName"
               @tab-click="handleClick">
        <el-tab-pane v-for="item,index in tabList"
                     :key="index"
                     :label="item.lable"
                     :name="item.name">
          <!-- ------------------------方案列表------------------------ -->
          <div v-for="item,index in plan_data"
               ref="htem_list"
               :key="index">
            <!-- 基本数据: 点击方案，返回数据 更新 地图 -->
            <div class="block_plan_item"
                 @click="selectDrivingPlan(item,index)">
              <div>
                方案:{{index+1}}
                <span style="float:right"
                      v-for="item,index in item.tags"
                      :key="index">
                  <el-tag size="mini"
                          v-if="item=='LEAST_LIGHT'">红绿灯少</el-tag>
                  <el-tag size="mini"
                          v-if="item=='LEAST_TRANSFER'">少换乘</el-tag>
                  <el-tag size="mini"
                          v-if="item=='时间短'">时间短</el-tag>
                  <el-tag size="mini"
                          v-if="item=='LEAST_WALKING'">少步行</el-tag>
                </span>

              </div>
              <p>距离： {{(item.distance/1000).toFixed(1)}} 公里; 时间：{{item.duration}}分钟。打车花费约：{{item.taxi_fare.fare}}元</p>
              <el-button style="width:100%;margin-top:10px"
                         size="mini"
                         @click="getInnerHtml(item,index)">选择</el-button>
            </div>
          </div>

        </el-tab-pane>

      </el-tabs>

    </el-card>
  </div>
</template>

<script>
export default {
  name: 'driving-plan-show',
  data() {
    return {
      plan_data: this.planData,
      activeName: this.tabList[0].name,
    }
  },
  props: {
    planData: Array,
    tabList: {
      type: Array,
      default: () => {
        return [
          { lable: '推荐', name: 'first' },
          { lable: '不堵车', name: 'second' },
          { lable: '少收费', name: 'third' },
        ]
      },
    },
  },
  watch: {
    planData(newVal) {
      this.plan_data = newVal
    },
  },
  methods: {
    handleClick() {},
    selectDrivingPlan(item, index) {
      // console.log(item)
      // console.log(index)
      let pl_list = this.renewMakeRoutesDriving(item)
      // console.log(pl_list)
      this.$emit('selectDrivingPlan', pl_list)
    },

    // 重新绘制驾车路线
    renewMakeRoutesDriving(item) {
      // console.log(item)
      let pl_list = []

      let pl = this.dealWithPolyline(item.polyline)
      // 构建 pl_list_item
      let pl_wlaking_item = {
        id: this.traffic_id,
        styleId: 'style_driving',
        paths: pl,
      }
      pl_list.push(pl_wlaking_item)
      return pl_list
    },
    // 解压 polyline
    dealWithPolyline(polyline) {
      let coors = polyline
      let pl = []
      //坐标解压（返回的点串坐标，通过前向差分进行压缩）
      let kr = 1000000
      // 不知道为什么但是去掉了就管用 哈哈哈哈
      // for (let i = 2; i < coors.length; i++) {
      //   coors[i] = Number(coors[i - 2]) + Number(coors[i]) / kr
      // }
      //将解压后的坐标生成LatLng数组
      for (var i = 0; i < coors.length; i += 2) {
        pl.push(new TMap.LatLng(coors[i], coors[i + 1]))
      }
      // console.log(pl)
      return pl
    },
    // 发送方案 和 方案说明
    getInnerHtml(item, index) {
      // console.log(index)
      // console.log(item)
      // console.log(this.$refs.htem_list)
      // console.log(this.$refs.htem_list[index])
      const ser = new XMLSerializer()
      const element = this.$refs.htem_list[index]
      const str = ser.serializeToString(element)

      // 格式化 dom
      let introduce = str
        .replace(/<div.*?>/g, '')
        .replace(/<\/div.*?>/g, '')
        .replace(/<span.*?>/g, '')
        .replace(/<\/span.*?>/g, '')
        .replace(/<\/p.*?>/g, '</p>')
        .replace(/<p.*?>/g, '<p>')
        .replace(/<!----><!---->/g, '')
        .replace(/<button.*\/button>/g, '')

      // const reg = /<\/?.+?\/?>/g
      // const reg = /<div.*?>/g
      // const val = str.replace(reg, '')
      // console.log(item)
      // .replace(/<(style|script|iframe)[^>]*?>[\s\S]+?<\/\1\s*>/gi, '')
      // .replace(/<[^>]+?>/g, '')
      // .replace(/\s+/g, ' ')
      // .replace(/ /g, ' ')
      // .replace(/>/g, ' ')

      this.$emit('bandTransitPlan', item, introduce)
    },
  },
}
</script>

<style scoped>
.block_plan_item {
  background-color: lightgray;
  padding: 10px;
  margin: 5px;
  cursor: pointer;
}
.block_plan_item_detail {
  margin: 5px;
  padding: 10px;
}
</style>